// extracted by mini-css-extract-plugin
export default {"addTransactionButton":"AddTransactionButton_addTransactionButton__BF3ad"};